import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { CarBrand } from '@/types';
import { useUpdateCarBrandMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdateCarBrandProps extends DialogProps {
  carBrand: CarBrand;
  onClose(): void;
}

const UpdateCarBrand: React.FC<UpdateCarBrandProps> = ({ carBrand, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [updateCarBrand, updateCarBrandResponse] = useUpdateCarBrandMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<CarBrand>({
    initialValues: carBrand ?? {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(carBrand, { resetForm }) {
      try {
        await updateCarBrand(carBrand).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать бренд автомобиля</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updateCarBrandResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updateCarBrandResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updateCarBrandResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateCarBrand;
